import React from 'react';

interface ViewMoreProps {
  productId: string;
}

function ViewMore({ productId }: ViewMoreProps) {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: `
            <esi:include src="/fragment/prdi-pdp-extensions-fe/view-more/${productId}" />`,
      }}
    />
  );
}

export default ViewMore;
